<template>
  <!-- star -->
  <div class="cooperation_wrap">
    <navigation></navigation>
    <div class="banner_warp">
      <img class="banner_warp_img" src="../assets/img/cooperation/cooperation_banner.png"/>
    </div>

    <!-- cooperation -->
    <div class="cooperation">
      <div class="cooperation-top"></div>
      <h1>商务合作</h1>
      <div class="cooperation-line"></div>
      <div class="cooperation-content">
        <el-form :model="cooperationForm" :rules="rules" label-position="top" ref="cooperationForm" label-width="80px"
                 class="cooperation-form">
          <div class="cooperation-label"><h2>基本信息</h2>
            <div class="cooperation-label-line"></div>
          </div>
          <el-row>
            <el-form-item label="姓名" prop="contactName">
              <el-input v-model="cooperationForm.contactName" placeholder="请输入您的姓名"
                        autocomplete="new-password"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="电话" prop="mobile">
              <el-input v-model="cooperationForm.mobile" placeholder="请输入您的电话号码" autocomplete="new-password"></el-input>
            </el-form-item>
          </el-row>
          <el-row class="cooperation-el-row"> <!--:gutter="80"-->
            <el-col class="cooperation-el-col" :span="12">  <!--:span="12"-->
              <el-form-item label="省份" class="cooperation-el-item" prop="province">
                <el-select @change="handleChangeProvince" v-model="cooperationForm.province" filterable
                           placeholder="请选择省份"
                           autocomplete="new-password" class="cooperation-el-select">
                  <el-option v-for="item in provinceData" :key="item.value" :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col class="cooperation-el-col" :span="12"> <!--:span="12"-->
              <el-form-item label="城市" class="cooperation-el-item" prop="city">
                <el-select v-model="cooperationForm.city" filterable placeholder="请选择城市" autocomplete="new-password"
                           class="cooperation-el-select">
                  <el-option v-for="item in cityData" :key="item.value" :label="item.label"
                             :value="item.label"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="cooperation-space"></div>
          <div class="cooperation-label"><h2>企业信息</h2>
            <div class="cooperation-label-line"></div>
          </div>
          <el-row>
            <el-form-item label="公司名称" prop="companyName">
              <el-input v-model="cooperationForm.companyName" placeholder="请输入公司名称"
                        autocomplete="new-password"></el-input>
            </el-form-item>
          </el-row>
          <div class="cooperation-space"></div>
          <div class="cooperation-label"><h2>合作需求</h2>
            <div class="cooperation-label-line"></div>
          </div>
          <el-row>
            <el-form-item label="合作需求" prop="remark">
              <el-input type="textarea" v-model="cooperationForm.remark" placeholder="请输入合作需求"
                        autocomplete="new-password"></el-input>
            </el-form-item>
          </el-row>
          <el-row class="cooperation-button-row">
            <el-form-item class="cooperation-el-form-item">
              <el-button class="cooperation-el-button" type="primary" @click="submitForm('cooperationForm')">提交
              </el-button>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
    </div>

    <footer2></footer2>
    <!-- end -->
  </div>
</template>

<script>
import navigation from "../components/nav2.vue";
import footer2 from "../components/footer.vue";
import {addCooperation} from "@/api";
import {regionData, codeToText} from 'element-china-area-data'

export default {
  name: "service",
  components: {
    navigation,
    footer2
  },
  data() {
    let validateMobile = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入电话号码'));
      } else {
        let newValue = value.replace(/[^0-9]/gi, '')
        if (value !== newValue) {
          callback(new Error('请输入正确的电话号码'))
        } else if (newValue.length !== 11) {
          callback(new Error('请输入正确的电话号码'))
        } else {
          callback()
        }
      }
    };
    return {
      provinceData: regionData,
      cityData: [],
      cooperationForm: {
        contactName: '',
        mobile: '',
        province: '',
        city: '',
        companyName: '',
        remark: '',
        productType: '',
      },
      rules: {
        contactName: [
          {required: true, message: '请输入您的姓名', trigger: 'blur'},
        ],
        mobile: [
          {required: true, validator: validateMobile, trigger: 'blur'},
        ],
        province: [
          {required: true, message: '请选择省份', trigger: 'blur'},
        ],
        city: [
          {required: true, message: '请选择城市', trigger: 'blur'},
        ],
        companyName: [
          {required: true, message: '请输入企业名称', trigger: 'blur'},
        ],
        remark: [
          {required: true, message: '请输入合作需求', trigger: 'blur'},
        ],
        productType: [
          {required: true, message: '请选择产品类型', trigger: 'blur'},
        ]
      }
    };
  },
  mounted() {
  },
  methods: {
    handleChangeProvince(value) {
      this.cityData = []
      this.cooperationForm.city = ''
      const province = codeToText[value]
      this.cooperationForm.province = province;
      if (province === '北京市' || province === '天津市' || province === '上海市' || province === '重庆市' ||
          province === '香港特别行政区' || province === '澳门特别行政区') {
        const city = {value: value, label: province}
        this.cityData.push(city)
      } else {
        const childList = this.provinceData.find(i => i.value === value).children
        this.cityData.push(...childList)
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
          addCooperation(this.cooperationForm).then(response => {
            this.$message({
              message: '提交成功',
              type: 'success'
            });
          });
        } else {
          // console.log('error submit!!');
          this.$message.error('请输入必填项！');
          return false;
        }
      });
    }
  }
};
</script>
<style scoped>
/*=========================Reset_start==========================*/
/*去内外边距*/
html,
body {
  font-family: "微软雅黑", "宋体", Arail, Tabhoma;
  text-align: left;
}

/*字体 文本居左*/
ul {
  list-style: none;
}

/*去ul li 小点*/
img {
  border: 0 none;
}

/*img IE6 兼容问题*/
input,
select,
textarea {
  outline: 0;
}

/*去除点击蓝框*/
textarea {
  resize: none;
  overflow: auto;
}

/*锁定多行文本框大小 与文字超出出现滚动条*/
table {
  border-collapse: collapse;
  border-spacing: 0;
}

/*表格边框合并 边框间距0*/
th,
strong,
var,
em {
  font-weight: normal;
  font-style: normal;
}

/*特殊文字粗细 样式显示正常*/
a {
  text-decoration: none;
}

/*a标签去下划线*/
.clearfix:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
}

/*清浮动*/
a {
  color: #000000;
}

/*==========================Reset_End===========================*/
.cooperation_wrap {
  width: 100vw;
  margin: 0 auto;
  /*height: 1000px;*/
}

.banner_warp {
  width: 1920px;
  height: 364px;
}

.banner_warp_img {
  width: 1920px;
  z-index: -999;
  position: absolute;
  height: 364px;
}

.cooperation {
  width: 100%;
  height: 1500px;
  background-size: contain;
}

.cooperation h1 {
  color: #000000;
  font-size: 24px;
  line-height: 90px;
  text-align: center;
  font-weight: 600;
  font-family: PingFang SC, PingFang SC;
}

.cooperation-top {
  width: 100%;
  padding-top: 60px;
}

.cooperation-line {
  margin: auto;
  width: 252px;
  height: 0px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #B1B1B1;
}

.cooperation-content {
  width: 740px;
  height: 1300px;
  margin: 0 auto;
  margin-top: 50px;
}

.cooperation-form {
  width: 740px;
  height: 900px;
}

.el-row {
  padding-top: 20px;
}

.el-form-item {
  width: 740px;
  height: 90px;
}

.cooperation-el-row {
  margin-right: -40px;
  margin-left: -40px;
}

.cooperation-el-col {
  /*float: left;*/
  padding-right: 40px;
  padding-left: 40px;
}

/deep/ .el-col-24 {
  /*width: 410px;*/
}

.cooperation-el-item {
  width: 330px;
  height: 90px;
}

.cooperation-el-select {
  width: 330px;
  /*height: 90px;*/
}

/deep/ .el-form-item__label {
  line-height: 40px;
  font-size: 14px;
  color: #000000;
  font-weight: 600;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  margin-right: 4px;
  color: #E92424;
}

/deep/ .el-form-item__content {
  line-height: 40px;
  font-size: 14px;
}

/deep/ .el-input {
  font-size: 14px;
}

/deep/ .el-input__inner {
  line-height: 40px;
  border-radius: 4px;
  height: 40px;
  padding: 0 15px;
  border: 1px solid #DCDFE6;
}

.cooperation-label h2 {
  color: #4B72B8;
  font-weight: 600;
  line-height: 19px;
  font-family: PingFang SC, PingFang SC;
  font-size: 16px;
}

.cooperation-label-line {
  margin-top: 12px;
  width: 110px;
  height: 0px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #4B72B8;
}

.cooperation-space {
  margin-top: 50px;
}

.el-textarea {
  width: 740px;
  height: 300px;
}

/deep/ .el-textarea__inner {
  padding: 5px 15px;
  width: 740px;
  height: 300px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  font-size: 14px;
}

.cooperation-button-row {
  margin-top: 230px;
  width: 740px;
  height: 132px;
}

.cooperation-el-form-item {
  margin-top: 50px;
  margin-left: 260px;
}

.cooperation-el-button {
  background-color: #4B72B8;
  width: 237px;
  height: 42px;
  border-radius: 0px 0px 0px 0px;
  font-size: 14px;
  padding: 12px 20px;
  border: 1px solid #4B72B8;
}

/deep/ .el-form-item__error {
  font-size: 12px;
  padding-top: 4px;
}

.el-select-dropdown__item {
  font-size: 14px;
  line-height: 34px;
}

/deep/ .el-input__suffix {
  right: 5px;
}

/deep/ .el-input__icon {
  width: 25px;
  line-height: 40px;
}

.el-button--primary:focus, .el-button--primary:hover {
  background-color: #4B72B8;
  border-color: #4B72B8;
}

.cooperation-form {
  height: 1250px;
}
</style>
